__turbopack_context__.v({
  "checkboxes": "MessageField-module__907wta__checkboxes",
});
